import { LogOut } from "lucide-react";
import { useRole } from "@/contexts/RoleContext";
import { useLang } from "@/contexts/LanguageContext";

export default function LogoutButton({ testid = "logout-button", compact = false }) {
  const { logOut } = useRole();
  const { t } = useLang();
  if (compact) {
    return (
      <button
        onClick={logOut}
        data-testid={testid}
        className="min-h-[48px] min-w-[56px] px-2 py-1 border border-[#262626] hover:border-[#FF3B30] hover:text-[#FF3B30] flex flex-col items-center justify-center gap-1 text-[10px] font-semibold uppercase tracking-wide whitespace-nowrap transition-colors"
      >
        <LogOut size={16} /> <span>{t("signOut")}</span>
      </button>
    );
  }
  return (
    <button
      onClick={logOut}
      data-testid={testid}
      aria-label={t("signOut")}
      title={t("signOut")}
      className="min-h-[44px] px-3 py-2 border border-[#262626] hover:border-[#FF3B30] hover:text-[#FF3B30] font-mono-label text-[11px] inline-flex items-center gap-2 whitespace-nowrap transition-colors"
    >
      <LogOut size={16} />
    </button>
  );
}
